import script from "./Calendar.vue?vue&type=script&setup=true&lang=js"
export * from "./Calendar.vue?vue&type=script&setup=true&lang=js"

import "./Calendar.vue?vue&type=style&index=0&id=57a848ab&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57a848ab"]])

export default __exports__